module.exports = __webpack_public_path__ + "static/media/wobster.744f9e37.webp";